import React, { useEffect } from 'react';
import cn from 'classnames';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getFixesState, setFixesState } from '@Managers/Redux/AppState/AppState';
import arrayCopy from '@Tools/ArrayCopy';

// STYLES
import styles from '../Fixes.scss';

const FixesCombinationsButton: React.FC<{ index: number; option: string }> = ({ index, option }) => {
    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);

    function disableFix(index: number) {
        const _array = arrayCopy(fixesState.fixCombinations);
        _array.splice(index, 1);
        dispatch(setFixesState({ fixCombinations: _array }));
    }

    return (
        <div key={index} className={cn(styles.fix_combinations_item, index === fixesState.currentIndex ? styles.active : false)}>
            <span className={styles.fix_combinations_step}>Step: {index} </span>
            <div className={styles.fix_list_item}>
                <button className={styles.fix_list_option}>{option}</button>
                <button className={styles.fix_list_delete} onClick={() => disableFix(index)}>
                    X
                </button>
            </div>
        </div>
    );
};

export default FixesCombinationsButton;
